import React from 'react';
import { Lightbulb, Key, Brain, Shield, CreditCard } from 'lucide-react';

/**
 * Компонент с предложениями по типам паролей для разных случаев
 */
const PasswordGeneratorSuggestions = ({ setFormData, initialFormData }) => {
  // Предустановленные настройки для разных типов паролей
  const passwordPresets = [
    {
      id: 'strong-password',
      name: 'Надежный пароль',
      description: 'Максимально защищенный пароль для важных аккаунтов',
      icon: Shield,
      color: 'text-emerald-500',
      settings: {
        ...initialFormData,
        passwordType: 'random',
        length: 16,
        includeUppercase: true,
        includeLowercase: true,
        includeNumbers: true,
        includeSymbols: true,
      }
    },
    {
      id: 'memorable-password',
      name: 'Запоминаемый пароль',
      description: 'Легко запоминающийся, но достаточно надежный пароль',
      icon: Brain,
      color: 'text-blue-500',
      settings: {
        ...initialFormData,
        passwordType: 'memorable',
        wordCount: 4,
        wordSeparator: '-',
        includeRandomCase: true,
        includeRandomNumbers: true,
      }
    },
    {
      id: 'bank-password',
      name: 'Пароль для банка',
      description: 'Соответствует требованиям большинства российских банков',
      icon: CreditCard,
      color: 'text-violet-500',
      settings: {
        ...initialFormData,
        passwordType: 'random',
        length: 10,
        includeUppercase: true,
        includeLowercase: true,
        includeNumbers: true,
        includeSymbols: false,
      }
    },
    {
      id: 'pin-code',
      name: 'PIN-код',
      description: 'Цифровой пароль для карт и устройств',
      icon: Key,
      color: 'text-orange-500',
      settings: {
        ...initialFormData,
        passwordType: 'pin',
        pinLength: 6,
      }
    },
  ];
  
  // Применение предустановленных настроек
  const applyPreset = (preset) => {
    setFormData(preset.settings);
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5 mb-8">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Lightbulb className="w-5 h-5 mr-2 text-yellow-500" />
        Предложения по генерации паролей
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {passwordPresets.map((preset) => (
          <div 
            key={preset.id}
            onClick={() => applyPreset(preset)}
            className="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
          >
            <div className="flex items-center mb-2">
              <preset.icon className={`w-5 h-5 mr-2 ${preset.color}`} />
              <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                {preset.name}
              </h4>
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              {preset.description}
            </p>
          </div>
        ))}
      </div>
      
      <div className="mt-4 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800 rounded-lg">
        <div className="flex items-start">
          <Lightbulb className="w-4 h-4 text-yellow-600 dark:text-yellow-400 mt-0.5 mr-2 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-yellow-700 dark:text-yellow-300 mb-1">
              Совет
            </h4>
            <p className="text-xs text-yellow-600 dark:text-yellow-400">
              Выбирайте тип пароля в зависимости от важности аккаунта. Для критичных аккаунтов (email, банк, госуслуги) используйте максимально надежные пароли. Для социальных сетей и форумов можно использовать запоминаемые пароли средней сложности.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordGeneratorSuggestions;